import { render, staticRenderFns } from "./BookList.vue?vue&type=template&id=1c654526&scoped=true"
import script from "./BookList.vue?vue&type=script&lang=js"
export * from "./BookList.vue?vue&type=script&lang=js"
import style0 from "./BookList.vue?vue&type=style&index=0&id=1c654526&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c654526",
  null
  
)

export default component.exports